import { TFunction } from 'i18next';
import img1 from '/public/main-page/automation-benefits-1.png';
import img2 from '/public/main-page/automation-benefits-2.png';
import img3 from '/public/main-page/automation-benefits-3.png';
import img4 from '/public/main-page/automation-benefits-4.png';

export const getAutomationBenefits = (t: TFunction) => {
  const benefits = t('mainPage.automationBenefits', { returnObjects: true }) as Array<{
    heading: string;
    description: string;
  }>;

  return [
    { ...benefits[0]!, img: img1 },
    { ...benefits[1]!, img: img2 },
    { ...benefits[2]!, img: img3 },
    { ...benefits[3]!, img: img4 },
  ];
};
